/** Marks each startup milestone once, without including account or workspace data. */
export function markStartup(
  stage: "entry" | "auth" | "catalog" | "connection" | "cached-workspace" | "live-workspace",
) {
  if (typeof performance === "undefined" || typeof performance.mark !== "function") return;
  const name = `maito:startup:${stage}`;
  if (performance.getEntriesByName(name).length === 0) performance.mark(name);
}
